import { BarChart2, Home, Search, User, Users } from "lucide-react";

import { SHADOW, TOKENS as T } from "../styles/styles";

// Floating bottom navigation from the Figma export. Single implementation,
// shared by every screen. Stats and Profile have no page yet, so they render but
// do not navigate.
const NAV_ITEMS = [
  { id: "tracker", label: "TRACKER", Icon: Home, navigable: true },
  { id: "search", label: "SEARCH", Icon: Search, navigable: true },
  { id: "groups", label: "GROUPS", Icon: Users, navigable: true },
  { id: "stats", label: "STATS", Icon: BarChart2, navigable: true },
  { id: "profile", label: "PROFILE", Icon: User, navigable: true },
];

export default function BottomNav({ active, onNavigate }) {
  return (
    <nav style={shellStyle}>
      <div style={barStyle}>
        {NAV_ITEMS.map(({ id, label, Icon, navigable }) => {
          const isActive = active === id;

          return (
            <button
              key={id}
              type="button"
              onClick={() => navigable && onNavigate?.(id)}
              style={buttonStyle}
            >
              <div
                style={{
                  ...iconBoxStyle,
                  background: isActive ? T.primary : "transparent",
                }}
              >
                <Icon size={20} color={isActive ? "#fff" : T.mutedForeground} />
              </div>
              <span
                style={{
                  ...labelStyle,
                  color: isActive ? T.primary : T.mutedForeground,
                }}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

const shellStyle = {
  position: "fixed",
  left: 0,
  right: 0,
  bottom: 0,
  padding: "0 12px 16px",
  zIndex: 30,
};

const barStyle = {
  display: "flex",
  alignItems: "center",
  padding: "6px 4px",
  background: "rgba(255,255,255,0.95)",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  borderRadius: 28,
  border: `1px solid ${T.border}`,
  boxShadow: SHADOW.nav,
};

const buttonStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 2,
  padding: "6px 0",
  background: "none",
  border: "none",
  cursor: "pointer",
  fontFamily: "inherit",
};

const iconBoxStyle = {
  width: 40,
  height: 40,
  borderRadius: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background 0.2s ease",
};

const labelStyle = {
  fontSize: 9,
  fontWeight: 700,
  letterSpacing: "0.04em",
};
